import React, { PureComponent } from 'react';
import noop from 'lodash/noop';

import SavedCreditCard from './SavedCreditCard';
import CreditCardSwitch, { NEW_CREDIT_CARD_OPTION_VALUE } from './CreditCardSwitch';
import NewCreditCard from './NewCreditCard';
import { creditCardType } from './types';
import {
  getByPath,
  buildChildrenTriggers,
  appendScript,
  RECAPTCHASITEKEY,
} from './utils/common';

import './CreditCard.scss';

const NEW_CARD = 'newCard';
const SAVED_CARD = 'savedCard';

class CreditCard extends PureComponent {
  static propTypes = creditCardType

  static defaultProps = {
    newCreditCardFields: {},
    savedCreditCardFields: {},
    trackingCallback: noop,
  }

  constructor(props) {
    super(props);
    const { triggers } = props;
    this.state = {
      currentChild: this.isAllSavedCardsExpired() ? NEW_CARD : SAVED_CARD,
      ...buildChildrenTriggers([ NEW_CARD, SAVED_CARD ], triggers, () => this.state.currentChild),
    };
  }

  componentDidMount() {
    const { amsConfig: { enableCaptcha } } = this.props;
    if (enableCaptcha) {
      const url = `https://www.recaptcha.net/recaptcha/api.js?render=${RECAPTCHASITEKEY}`;
      appendScript(url, null, true, 'head');
    }
  }

  isAllSavedCardsExpired = () => {
    const savedAccounts = getByPath(this.props, 'creditCardPaymentInfo.savedAccountInfo.savedAccounts');
    if (savedAccounts && savedAccounts.length) {
      return !savedAccounts.filter(savedAccount => !savedAccount.isExpired).length;
    }
    return true;
  }

  isValidateSavedCards = () => {
    const savedAccounts = getByPath(this.props, 'creditCardPaymentInfo.savedAccountInfo.savedAccounts');
    return !!(savedAccounts && savedAccounts.length);
  }

  isValidateNewCards = () => {
    const availableCardTypes = getByPath(this.props, 'creditCardPaymentInfo.newAccountInfo.availableCardTypes');
    return !!(availableCardTypes && availableCardTypes.length);
  }

  handleSwitch = (optionValue) => {
    const currentChild = optionValue === NEW_CREDIT_CARD_OPTION_VALUE ? NEW_CARD : SAVED_CARD;
    this.setState({ currentChild }, () => {
      const { trackingCallback } = this.props;
      currentChild === NEW_CARD && trackingCallback({ id: 'cui.addNewCreditCard.clicked' });
    });
  }

  render() {
    const {
      amsConfig, newCreditCardFields, savedCreditCardFields,
      creditCardPaymentInfo: { newAccountInfo, savedAccountInfo }, ...rest
    } = this.props;
    const { currentChild, savedCardTriggers, newCardTriggers } = this.state;
    const enableSavedCards = this.isValidateSavedCards();
    const enableNewCard = this.isValidateNewCards();
    const shouldShowNewCard = enableNewCard && currentChild === NEW_CARD;
    return (
      <div className="checkout__creditcard">
        { enableSavedCards && <SavedCreditCard
          amsConfig={amsConfig}
          {...savedAccountInfo}
          {...rest}
          fields={savedCreditCardFields}
          defaultAccount={shouldShowNewCard ? NEW_CREDIT_CARD_OPTION_VALUE : undefined}
          triggers={savedCardTriggers}
          creditCardSwitch={enableNewCard ? <CreditCardSwitch /> : null}
          handleSwitch={this.handleSwitch}/>}
        { shouldShowNewCard && <NewCreditCard
          amsConfig={amsConfig}
          {...newAccountInfo}
          {...rest}
          fields={newCreditCardFields}
          triggers={newCardTriggers}/>}
      </div>
    );
  }
}

export default CreditCard;
